export const LOCALE_COOKIE_NAME_STRING = 'sezzle__locale';
